import { Table, Tag, Space, message } from "antd";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { ColumnsType } from "antd/es/table";
import { useTranslation } from "react-i18next";
import { UseMutateAsyncFunction, useMutation } from "react-query";
import { deleteBrand, getBrandById } from "../../../api/brand";
import { AddEditBrand } from "./AddEditBrand";
import { BrandType } from "./brandType";
import EditButton from "../../UI/EditButton/editbutton";
import DeleteButton from "../../UI/DeleteButton/deletebutton";
import DeleteModal from "../../UI/ModalComponent/DeleteModal/deletemodal";
import { AxiosResponse } from "axios";

interface inventoryProps {
  paginatedBrand: any;
  setPaginatedBrand: Dispatch<any>;
  BrandsMutation: UseMutateAsyncFunction<
    AxiosResponse<any, any>,
    unknown,
    {
      limit: number;
      q: string;
      isActive?: boolean | undefined;
    },
    unknown
  >;
  filter: boolean | undefined;
  search: string;
  page: any;
  isBrandsLoading: boolean;
  setPage: Dispatch<SetStateAction<number>>;
  tableKey: string;
}
interface BrandInterface {
  id: number;
  name: string;
  abbreviation: string;
  isActive: boolean;
}

const BrandList = ({
  paginatedBrand,
  setPaginatedBrand,
  BrandsMutation,
  search,
  filter,
  page,
  isBrandsLoading,
  setPage,
  tableKey,
}: inventoryProps) => {
  const [t] = useTranslation("common");
  const [Brand, setBrand] = useState<BrandType>();
  const [openBrand, setOpenBrand] = useState(false);
  const [selectedBrand, setSelectedBrand] = useState<any>();
  const [prevPage, setPrevPage] = useState<number>(0);
  const [maxPage, setMaxPage] = useState<number>(0);
  const [, setError] = useState("");

  useEffect(() => {
    page > prevPage &&
      maxPage < page &&
      BrandsMutation({
        limit: page * 8 + 8,
        q: search,
        isActive: filter,
      }).then((res) => {
        if (page > maxPage) setMaxPage(page);
        setPaginatedBrand(res.data);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, filter]);

  const getBrandMutation = useMutation("getBrand", getBrandById);
  function fillBrand(id: any) {
    getBrandMutation.mutate(id, {
      onSuccess: (res) => {
        setBrand(res.data);
        setOpenBrand(true);
      },
    });
  }

  const onError = (error: any, context: unknown) => {
    if (setError) {
      setError(error.response.data.message);
      message.error({
        content: error.response.data.message,
        duration: 10,
        onClick: () => {
          message.destroy();
        },
      });
    }
  };

  const deleteBrandMutation = useMutation("deleteBrand", deleteBrand, {
    onSuccess: () => {
      BrandsMutation({
        limit: page * 8 + 8,
        q: search,
        isActive: filter,
      }).then((res: any) => {
        setPaginatedBrand(res.data);
        message.success("Complete successfully");
      });
    },
    onError,
  });
  const [open, setOpen] = useState(false);
  const [idToDelete, setIdToDelete] = useState<string | undefined>(undefined);
  const [nameToDelete, setNameToDelete] = useState<any>();

  const DeleteBrand = (id: string | undefined, name: string): void => {
    setOpen(true);
    setIdToDelete(id);
    setNameToDelete(name);
  };

  const handleOk = () => {
    if (idToDelete) {
      deleteBrandMutation.mutate({ id: idToDelete });
    }
    setOpen(false);
  };

  const columns: ColumnsType<BrandInterface> = [
    {
      title: `${t("brand-name")}`,
      dataIndex: "name",
      key: "name",
      className: "table-header",
    },
    {
      title: `${t("abbreviation")}`,
      dataIndex: "abbreviation",
      key: "abbreviation",
      width: "12rem",
    },
    {
      title: `${t("status")}`,
      align: "center",
      width: "5rem",
      dataIndex: "isActive",
      key: "isActive",
      render: (record: any) =>
        record ? (
          <Tag className="active">Active</Tag>
        ) : (
          <Tag className="inactive">Inactive</Tag>
        ),
    },
    {
      title: `${t("action")}`,
      key: "action",
      fixed: "right",
      width: "5rem",
      align: "center",
      render: (record: any) => (
        <Space>
          <EditButton
            onClick={() => {
              fillBrand(record.id);
              setSelectedBrand(record.id);
            }}
          />
          <DeleteButton onClick={() => DeleteBrand(record?.id, record?.name)} />
        </Space>
      ),
    },
  ];
  return (
    <>
      <DeleteModal
        open={open}
        setOpen={setOpen}
        name={nameToDelete}
        onOk={handleOk}
      />
      {openBrand && Brand && (
        <AddEditBrand
          page={page}
          search={search}
          filter={filter}
          openBrand={openBrand}
          setOpenBrand={setOpenBrand}
          Brand={Brand}
          id={selectedBrand}
          setPaginatedBrand={setPaginatedBrand}
          BrandsMutation={BrandsMutation}
        />
      )}
      <Table
        key={tableKey}
        scroll={{ x: 1000 }}
        columns={columns}
        dataSource={paginatedBrand}
        pagination={{ pageSize: 8 }}
        loading={isBrandsLoading}
        rowClassName={(record, index) =>
          index % 2 === 0
            ? "table-row-light table-row"
            : "table-row-dark table-row"
        }
        onChange={(selectedPage) => {
          setPrevPage(page);
          setPage(selectedPage?.current ?? 1);
        }}
        rowKey={(record) => record.id}
      />
    </>
  );
};

export default BrandList;
